import { toPersianDigits } from "./numberFormat";

// Persian field labels for API errors, and client-side checks that mirror
// the representation and accounts models, for the screens that edit them.
// Each validator returns { lines, fields }: toast lines ("label: problem")
// and per-field messages for screens that also mark the field inline.

const isBlank = (value) => String(value ?? "").trim() === "";

function check(values, { labels, required = [], maxLengths = {}, digits = [] }, extra = []) {
  const problems = [...extra];
  required.forEach((name) => {
    if (isBlank(values[name])) problems.push([name, "الزامی است."]);
  });
  Object.entries(maxLengths).forEach(([name, max]) => {
    if (String(values[name] ?? "").length > max) {
      problems.push([name, `حداکثر ${toPersianDigits(max)} نویسه مجاز است.`]);
    }
  });
  digits.forEach((name) => {
    if (!isBlank(values[name]) && !/^\d+$/.test(String(values[name]))) {
      problems.push([name, "فقط عدد مجاز است."]);
    }
  });
  const fields = {};
  problems.forEach(([name, message]) => {
    if (!fields[name]) fields[name] = message;
  });
  return { lines: problems.map(([name, message]) => `${labels[name]}: ${message}`), fields };
}

// ── Representation (وکالت‌نامه) ───────────────────────────

export const REPRESENTATION_LABELS = {
  representi: "موکل",
  representor: "وکیل",
  applicant: "درخواست دهنده",
  start_date: "تاریخ شروع",
  end_date: "تاریخ پایان",
  another_deligation: "حق توکیل به غیر",
  representor_dismissal: "عزل وکیل",
  representation_summary: "خلاصه وکالت",
  doc_number: "شماره سند",
  verification_code: "کد تصدیق",
  file: "فایل وکالت‌نامه",
};

export function validateRepresentation(form) {
  const people = ["representi", "representor"]
    .filter((name) => !form[name]?.length)
    .map((name) => [name, "حداقل یک نفر را انتخاب کنید."]);
  return check(
    form,
    {
      labels: REPRESENTATION_LABELS,
      required: ["start_date", "representation_summary", "doc_number", "verification_code"],
      maxLengths: { start_date: 55, end_date: 55, representation_summary: 255 },
    },
    people,
  );
}

// ── Check (چک) ─────────────────────────────────────────────

export const CHECK_LABELS = {
  check_code: "کد چک",
  bank: "بانک",
  issuer: "صادر کننده",
  issued_for: "در وجه",
  value: "مبلغ",
  date: "تاریخ چک",
  is_paid: "وضعیت پرداخت",
  document: "تصویر چک",
};

export function validateCheck(form) {
  return check(form, {
    labels: CHECK_LABELS,
    required: ["check_code", "bank", "issuer", "issued_for", "value", "date"],
    maxLengths: { bank: 255, issuer: 255, issued_for: 255, date: 255 },
    digits: ["check_code", "value"],
  });
}

// ── Customer (مشتری) ───────────────────────────────────────

export const CUSTOMER_LABELS = {
  full_name: "نام کامل",
  phone_number: "شماره تلفن",
  national_code: "کد ملی",
  customer_birthday: "تاریخ تولد",
  customer_address: "آدرس",
};

export function validateCustomer(form) {
  return check(form, {
    labels: CUSTOMER_LABELS,
    required: ["full_name"],
    maxLengths: { full_name: 255, phone_number: 100, national_code: 100, customer_birthday: 100 },
  });
}
